import { ListItemIcon, ListItemText, MenuItem, SxProps } from '@mui/material';
import React, { MouseEvent } from 'react';
import { SIZES } from '../../constants/constants';
import type { ActionType } from '../ActionType';
import Loading from '../Loading';

const MENU_ITEM_SX = {
    '.MuiListItemIcon-root': {
        minWidth: 'fit-content'
    },
    px: 1.5,
    py: 0
} as const;

type ResponsiveActionMenuItemProps = {
    action: ActionType;
    index: number;
    isAnyActionActive: boolean;
    iconSx?: SxProps;
    onSelect: (event: MouseEvent<HTMLElement>) => void;
};

export default function ResponsiveActionMenuItem({
    action,
    index,
    isAnyActionActive,
    iconSx,
    onSelect
}: ResponsiveActionMenuItemProps) {
    const dataTestId = action.dataTestId || `icon-action-${index}`;
    const disabled = action.disabled || isAnyActionActive;
    const handleClick = action.disabled
        ? undefined
        : (event: MouseEvent<HTMLElement>) => {
              action.onClick?.(event);

              onSelect(event);
          };
    const menuItemSx = {
        ...MENU_ITEM_SX,
        display: action.hidden ? 'none' : 'flex'
    };
    const menuItemContent = (
        <>
            <ListItemIcon>
                {action.loading ? (
                    <Loading size="18px" />
                ) : action.icon ? (
                    <action.icon
                        fontSize={SIZES.small}
                        sx={{
                            color: action.disabled ? 'text.disabled' : 'text.primary',
                            ...iconSx
                        }}
                    />
                ) : null}
            </ListItemIcon>
            <ListItemText>{action.label}</ListItemText>
        </>
    );

    const menuItemCommonProps = {
        'data-testid': dataTestId,
        disabled,
        onClick: handleClick,
        sx: menuItemSx
    };

    return <MenuItem {...menuItemCommonProps}>{menuItemContent}</MenuItem>;
}
